document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initShopBrandFilter();
  initConsignToggle();
  initProductGallery();
  initProductVariants();
  initViewingCounters();
});

function initMobileNav() {
  var burger = document.querySelector('.site-header__burger');
  var mobileNav = document.getElementById('MobileNav');
  if (!burger || !mobileNav) return;

  burger.addEventListener('click', function () {
    var isOpen = !mobileNav.hidden;
    mobileNav.hidden = isOpen;
    burger.setAttribute('aria-expanded', String(!isOpen));
  });
}

function initShopBrandFilter() {
  var grid = document.getElementById('ShopGrid');
  if (!grid) return;

  var params = new URLSearchParams(window.location.search);
  var brand = params.get('brand');
  if (!brand) return;

  var items = grid.querySelectorAll('.boot-grid__item');
  items.forEach(function (item) {
    if (item.getAttribute('data-brand') !== brand) {
      item.style.display = 'none';
    }
  });

  document.querySelectorAll('.brand-card').forEach(function (card) {
    if (card.getAttribute('data-brand') === brand) {
      card.classList.add('is-active');
    }
  });
}

function initProductGallery() {
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-page__thumb');
  if (!mainImage || !thumbs.length) return;

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      mainImage.src = thumb.getAttribute('data-full');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
    if (index === 0) thumb.classList.add('is-active');
  });
}

function initProductVariants() {
  var form = document.getElementById('ProductForm');
  var dataEl = document.getElementById('ProductVariants');
  if (!form || !dataEl) return;

  var variants = JSON.parse(dataEl.textContent);
  var variantIdInput = document.getElementById('ProductVariantId');
  var submitBtn = document.getElementById('ProductSubmit');
  var priceEl = document.getElementById('ProductPrice');
  var availabilityEl = document.getElementById('ProductAvailability');

  form.querySelectorAll('.variant-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var optionIndex = pill.getAttribute('data-option-index');
      form.querySelectorAll('.variant-pill[data-option-index="' + optionIndex + '"]').forEach(function (p) {
        p.classList.remove('is-selected');
      });
      pill.classList.add('is-selected');

      var selected = {};
      form.querySelectorAll('.variant-pill.is-selected').forEach(function (p) {
        selected[p.getAttribute('data-option-index')] = p.getAttribute('data-value');
      });

      var match = variants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          return v['option' + idx] === selected[idx];
        });
      });

      if (match) {
        variantIdInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
        if (availabilityEl) {
          availabilityEl.classList.toggle('product-page__badge--sold-out', !match.available);
          if (match.available) {
            availabilityEl.setAttribute('data-viewing-badge', '');
            availabilityEl.innerHTML = '<span class="live-dot" aria-hidden="true"></span><span class="viewing-count">' + randomViewingCount() + '</span> people viewing this';
            startViewingLoop(availabilityEl);
          } else {
            availabilityEl.removeAttribute('data-viewing-badge');
            availabilityEl.textContent = 'Sold Out';
          }
        }
      }
    });
  });
}

function randomViewingCount() {
  return Math.floor(Math.random() * 10) + 1;
}

function startViewingLoop(badge) {
  var countEl = badge.querySelector('.viewing-count');
  if (!countEl) return;

  function tick() {
    if (!badge.hasAttribute('data-viewing-badge')) return;
    countEl.textContent = randomViewingCount();
    setTimeout(tick, 4000 + Math.random() * 5000);
  }

  setTimeout(tick, 4000 + Math.random() * 5000);
}

function initViewingCounters() {
  document.querySelectorAll('[data-viewing-badge]').forEach(startViewingLoop);
}

function initConsignToggle() {
  var buttons = document.querySelectorAll('.consign__toggle-btn');
  var field = document.getElementById('ListingTypeField');
  if (!buttons.length || !field) return;

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      field.value = btn.getAttribute('data-listing-type');
    });
  });
}
